import { login as Auth0Login, signUp as Auth0SignUp } from "../../libraries/_modules/auth0";
import { trackUserFreemiumLoginWallCtaClicked } from "../../libraries/_modules/tracking/helpers";

const VIDEO_TYPES = {
  free: "Free",
  freemium: "Freemium",
  premium: "Premium",
};

export function getUserPlayVideoPermission({
  accountWall = null,
  isUserLogged = false,
}) {
  if (!accountWall) {
    return true;
  }

  const isVideoFreemium = accountWall === VIDEO_TYPES.freemium;
  const isVideoFree = accountWall === VIDEO_TYPES.free;

  if (isVideoFree || (isVideoFreemium && isUserLogged)) {
    return true;
  }

  return false;
}

export function openLoginPage() {
  trackUserFreemiumLoginWallCtaClicked({
    freemiumType: "video",
    ctaAction: "signin"
  });
  const redirect_uri = `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}&freemiumType=video&event=successful-login-freemium`
  Auth0Login(redirect_uri);
}

export function openSignupPage() {
  trackUserFreemiumLoginWallCtaClicked({
    freemiumType: "video",
    ctaAction: "signup"
  });
  const redirect_uri = `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}&freemiumType=video&event=successful-signup&signupType=freemium`
  Auth0SignUp(redirect_uri);
}


export function formatVideoDuration(videoDuration) {
  const seconds = Math.floor(videoDuration / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  return `${minutes}:${formattedSeconds}`;
}

export function isMobileBrowser() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return isMobile;
}
